import { gql } from '@apollo/client';

export const GET_HOUSEHOLD_MEMBERS = gql`
  query GetHouseholdMembers($input: StakeholderFilter) {
    members: getHouseholdMembers(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          firstName
          lastName
          householdId
          householdCode
          caseId
          nationalID
          gender {
            id
            name
          }
          dateOfBirth
          status
        }
        cursor
      }
    }
  }
`;
